export default __webpack_public_path__ + "static/media/hr-2.8a805e4f.png";